import { buildArgsAndVarDefs } from "@/utils/buildArgsAndVarDefs";

export function parseFragmentHeader(fragmentSource) {
    const m = /fragment\s+(\w+)\s+on\s+(\w+)/i.exec(fragmentSource);
    if (!m) throw new Error("Invalid fragment: expected 'fragment <Name> on <Type> { ... }'");
    return { fragmentName: m[1], typeName: m[2] };
}

/**
 * Always auto-builds args/varDefs from variables + typeMap.
 * No manual args/varDefs anymore.
 */
export function buildQuery({ fragment, field, variables = {}, typeMap = {} } = {}) {
    if (!fragment) throw new Error("buildQuery: 'fragment' is required");
    if (!field) throw new Error("buildQuery: 'field' is required");

    const { fragmentName } = parseFragmentHeader(fragment);

    const { argsStr, varDefsStr } = buildArgsAndVarDefs(variables, typeMap);

    const query = /* GraphQL */ `
        ${fragment}
        query${varDefsStr} {
          ${field}${argsStr} {
            ...${fragmentName}
          }
        }
      `;
    return { query };
}

export default { buildQuery, parseFragmentHeader };
